import React from 'react'
import Translate from '../../components/Translate'

function TranslatePage() {
  return (
    <>
    <Translate/>
    </>
  )
}

export default TranslatePage